// Tax Computation: the client uploads their own computation and we convert it to iXBRL. Free, UK only for now.
// Kept out of the region config so the existing regions' configuration (and its snapshot test) stays as it was.
export const TAX_COMPUTATION_ID = 'tax_computation';
export const HMRC_FILING_ID = 'hmrc_filing';
export const TAX_COMPUTATION_NOW = 'now';
export const TAX_COMPUTATION_LATER = 'later';
export const TAX_COMPUTATION_ACCEPT = '.pdf,.docx,.xlsx';

export const TAX_COMPUTATION_SERVICE = {
  id: TAX_COMPUTATION_ID,
  title: 'Tax Computation iXBRL',
  description: 'Your own tax computation, converted to iXBRL by us. No charge.',
  price: 0,
};

const REGIONS_OFFERING_TAX_COMPUTATION = new Set(['UK']);

export const offersTaxComputation = (regionCode) => REGIONS_OFFERING_TAX_COMPUTATION.has(regionCode);

// Service lists are arrays of ids in the current wizard and objects of booleans in older saved progress.
export const orderedServiceIds = (wizardData) => {
  const services = wizardData?.optionalServices;
  if (Array.isArray(services)) return services;
  return Object.keys(services || wizardData?.solutions || {}).filter((id) => (services || wizardData?.solutions)[id]);
};

export const ordersTaxComputation = (wizardData) => orderedServiceIds(wizardData).includes(TAX_COMPUTATION_ID);

// The catalogue the order summaries price from, with Tax Computation added where it is offered.
export const withTaxComputation = (catalogue, regionCode) =>
  offersTaxComputation(regionCode) ? { ...catalogue, [TAX_COMPUTATION_ID]: TAX_COMPUTATION_SERVICE } : catalogue;

// A CT600 cannot be filed without a tax computation in iXBRL, so choosing HMRC filing adds it to the order, free.
// It is never sold on its own.
export const needsTaxComputationForFiling = (serviceIds, regionCode) =>
  offersTaxComputation(regionCode) && serviceIds.includes(HMRC_FILING_ID);

// With HMRC filing the client either uploads the computation with their documents or sends it separately.
export const sendsTaxComputationLater = (wizardData) => wizardData?.config?.taxComputationTiming === TAX_COMPUTATION_LATER;

// The upload step asks for the computation only when it is ordered and not being sent separately.
export const uploadsTaxComputationNow = (wizardData) => ordersTaxComputation(wizardData) && !sendsTaxComputationLater(wizardData);
